import React from 'react'

export function Setting() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="31.671" height="19" viewBox="0 0 31.671 19"><path d="M24.486,18.835H3.584A1.5,1.5,0,0,1,2,17.251a1.5,1.5,0,0,1,1.584-1.584h20.9a4.635,4.635,0,0,1,6.017-2.85,4.765,4.765,0,0,1,2.85,6.017,4.708,4.708,0,0,1-8.868,0Zm-19-9.5h-1.9A1.5,1.5,0,0,1,2,7.75,1.5,1.5,0,0,1,3.584,6.167h1.9A4.525,4.525,0,0,1,11.5,3.316a4.627,4.627,0,0,1,2.85,2.85H32.087A1.5,1.5,0,0,1,33.671,7.75a1.5,1.5,0,0,1-1.584,1.584H14.352a4.525,4.525,0,0,1-6.017,2.85,4.627,4.627,0,0,1-2.85-2.85Z" transform="translate(-2 -3.001)"/></svg>
  )
}
